import { legacyTheme } from 'styles/theme';
import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';
import { ResolutionAwareProp } from 'types/resolution-aware-prop.type';
import { ExtractStyleFromResolutionAwarePropEntry } from 'types/layout';
import { generateStylesForResolutionAwareProps } from 'helpers/layout.helpers';
import { Property } from 'csstype';

export const StyledAnimatedImage = styled(animated.img)<{
  fit: ResolutionAwareProp<Property.ObjectFit>;
  innerheight: ResolutionAwareProp<Property.Height>;
  position: ResolutionAwareProp<Property.ObjectPosition>;
  size: ResolutionAwareProp<string>;
}>`
  ${({ fit, innerheight, position, size }) => {
    const entries: ExtractStyleFromResolutionAwarePropEntry[] = [
      {
        cssProperty: 'object-fit',
        resolutionAwareProp: fit || size,
      },
      {
        cssProperty: 'height',
        resolutionAwareProp: innerheight,
      },
      {
        cssProperty: 'object-position',
        resolutionAwareProp: position,
      },
    ];

    return css`
      position: relative;
      width: 100%;
      ${generateStylesForResolutionAwareProps(entries)}
    `;
  }}
`;

export const StyledAnimatedImageLoading = styled(animated.div)`
  ${({ theme }) => {
    return css`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${legacyTheme.colors.cream};
    `;
  }}
`;
